// extracted by mini-css-extract-plugin
export default {"wrapper":"Rp-z","response":"Sp-z","error":"Tp-z","disabled":"Up-z","buttons":"Vp-z","feedbackQuestionSection":"Wp-z","yesNoWrapper":"Xp-z"};